import { Component, OnInit } from '@angular/core';
import { ContinuousActivity, ContinuousActivityModel } from 'src/app/models/activities';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
  selector: 'wm-continuous-activity-view',
  templateUrl: './continuous-activity-view.component.html',
  styleUrl: './continuous-activity-view.component.css',
  standalone: false
})
export class ContinuousActivityViewComponent extends ActivityView
  implements OnInit {
  activity: ContinuousActivity;
  model: ContinuousActivityModel;

  constructor() {
    super();
  }

  ngOnInit() {
    this.model = new ContinuousActivityModel(
      this.activity.model ? this.activity.model : null
    );
  }
}